/* @flow */

import DepotSettingsClient from "../clients/DepotSettingsClient";
import { SessionStore } from "shared/src/uidispatcherapi/SessionStore";
import { Store } from "shared/src/stores/Store";
import TrackingUtil from "shared/src/utils/TrackingUtil";
import { StoreType } from "../datatypes/Store";
import { isEmpty } from "shared/src/utils/util";

type State = {
    stores: StoreType[];
    isLoading: boolean;
};

let state: State;

/**
 * Contains data for all stores from depotsettings.
 */
class MetroStoresStore extends Store {
    constructor() {
        super();
        state = this.getEmptyState();
        this.listenTo(SessionStore, this.loadStoresFromDepotSettings);
        this.loadStoresFromDepotSettings();
    }

    getEmptyState(): State {
        return {
            stores: [],
            isLoading: false
        };
    }

    loadStoresFromDepotSettings() {
        if (!SessionStore.pending() && isEmpty(state.stores) && !state.isLoading) {
            state.isLoading = true;
            DepotSettingsClient.getStoresForCountry(SessionStore.getCountry())
                .then(this.onGetStoresSuccess)
                .catch((e) => {
                    state.isLoading = false;
                    TrackingUtil.trackUiErrorSd("MetroStoresStore", "Fetching stores failed: ", e);
                });
        }
    }

    onGetStoresSuccess = (response: StoreType[]) => {
        state.isLoading = false;
        state.stores = response.map((store) => {
            const printName = store?.printoutInformation?.printName;
            store.storeDisplayName = printName || store.storeName;
            return store;
        });
        this.trigger();
    };

    getStores(): StoreType[] {
        return state.stores;
    }

    getStoreByNumber(storeNumber: string): StoreType | undefined | null {
        return state.stores.find((store) => store.storeId && store.storeId.locationNumber === storeNumber);
    }

    resetState() {
        state = this.getEmptyState();
    }
}

export default new MetroStoresStore();
